// import React from "react";
// import { Video, Image, FileText } from "lucide-react";

// const user = {
//   name: "Biswajit",
//   avatar: "",
// };

// const PostComposer = () => {
//   const handlePost = () => console.log("Open Post Modal");
//   const handleVideo = () => console.log("Upload Video");
//   const handlePhoto = () => console.log("Upload Photo");
//   const handleArticle = () => console.log("Write Article");

//   return (
//     <div className="bg-white/80 rounded-xl shadow-md relative border-b-2 border-palatte2 p-5">
//       <div className="flex items-center gap-4">
//         <div className="h-14 w-14 rounded-full overflow-hidden shadow-md ring-2 ring-white">
//           {user.avatar ? (
//             <img
//               src={user.avatar}
//               alt="User Avatar"
//               className="h-full w-full object-cover"
//             />
//           ) : (
//             <div className="h-full w-full flex items-center justify-center bg-palatte2 text-white text-2xl font-bold">
//               {user.name?.charAt(0)}
//             </div>
//           )}
//         </div>

//         <button
//           onClick={handlePost}
//           className="flex-1 text-left text-sm font-semibold px-5 py-3 rounded-full bg-gray-white hover:bg-gray-50 border border-gray-200 shadow-md transition-all duration-300 text-gray-600"
//         >
//           What’s on your mind today?
//         </button>
//       </div>

//       <div className="h-px bg-gradient-to-r from-transparent via-gray-300 to-transparent my-5" />
//       <div className="flex justify-between gap-3 ">
//         {/* <ActionButton
//           icon={<Video size={18} />}
//           label="Video"
//           onClick={handleVideo}
//         /> */}

//         <ActionButton
//           icon={<Image size={18} />}
//           label="Photo"
//           onClick={handlePhoto}
//         />

//         {/* <ActionButton
//           icon={<FileText size={18} />}
//           label="Article"
//           onClick={handleArticle}
//         /> */}
//       </div>
//     </div>
//   );
// };

// const ActionButton = ({ icon, label, btnStyle, onClick }) => {
//   return (
//     <button
//       onClick={onClick}
//       className={`flex items-center gap-2 px-4 py-2 rounded-full text-gray-700 text-sm font-semibold shadow hover:scale-105 active:scale-95 transition-all duration-300  ${btnStyle}`}
//     >
//       {icon}
//       {label}
//     </button>
//   );
// };

// export default PostComposer;

import React, { useState } from "react";
import PostCreateModal from "./PostCreateModal";
import { useSelector } from "react-redux";

const PostComposer = ({ onPostCreated }) => {
  const { session } = useSelector((state) => state?.authProvider);

  const loggedinUser = session?.user || {};

  const fullName =
    [loggedinUser?.firstName, loggedinUser?.lastName]
      .filter(Boolean)
      .join(" ") || "User";

  const firstLetter =
    loggedinUser?.firstName?.charAt(0)?.toUpperCase() ||
    loggedinUser?.email?.charAt(0)?.toUpperCase() ||
    "U";

  const profileImage = loggedinUser?.image?.url || null;

  const [open, setOpen] = useState(false);

  return (
    <>
      <div className="bg-white/80 rounded-xl shadow-md border-b-2 border-palatte2 p-5">
        <div className="flex items-center gap-4">
          {profileImage ? (
            <img
              src={profileImage}
              alt={fullName}
              className="h-10 w-10  rounded-full object-cover"
            />
          ) : (
            <div className="h-10 w-10  rounded-full bg-palatte flex items-center justify-center text-white text-base md:text-xl font-bold">
              {firstLetter}
            </div>
          )}

          <button
            onClick={() => setOpen(true)}
            className="flex-1 text-left text-sm font-semibold px-5 py-3 rounded-full bg-gray-50 border border-gray-200 shadow-md text-gray-600"
          >
            What’s on your mind?
          </button>
        </div>
      </div>

      {open && (
        <PostCreateModal
          onClose={(newPost) => {
            setOpen(false);

            if (newPost && newPost._id) {
              onPostCreated(newPost);
            }
          }}
        />
      )}
    </>
  );
};

export default PostComposer;
